var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentSettings
    ? _c(
        "div",
        [
          _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
            _vm._v(_vm._s(_vm.EVENT_SETTINGS_MUST_RELOAD)),
          ]),
          _vm._v(" "),
          _vm._l(_vm.parameters, function (parameter) {
            return _c(
              "div",
              { key: parameter.parameter_name },
              [
                parameter && !_vm.exclusions.includes(parameter.parameter_name)
                  ? _c("config-editor", {
                      attrs: { model: "configuration", parameter: parameter },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
            _vm._v(_vm._s(_vm.EVENT_SETTINGS_MUST_RELOAD)),
          ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }